import { Trans, t } from '@lingui/macro';

import FormSection from '../../form/FormSection';
import { GROUPS_ADMIN_SITES_COLUMNS, GROUPS_ADMIN_SITES_FIELD } from './GroupsAdminConstants';
import ListSelectorField from '../../form/ListSelectorField';
import { SORT_ASC } from '../../../utilities/FormUtilities';
import { useGroupAdminStyles } from './GroupsAdminUtils';

const initialSort = [{ property: 'name', direction: SORT_ASC }];
const selectionDataSource = {
    totalProperty: 'count',
    dataProperty: 'data',
    params: {
        searchFields: ['name', 'description', 'tags'],
    },
    initialSort,
};

const selectedDataSource = {
    ...selectionDataSource,
    url: '/query/admin/sites/findSelected',
};

const availableDataSource = {
    ...selectionDataSource,
    url: '/query/admin/sites/findAvailable',
};

const idsDataSource = {
    params: selectionDataSource.params,
    url: '/query/admin/sites/selectionUUIDs',
};

export function GroupsAdminSitesSection({ formData, setSitesSelectionDirty, isEditingDefaultGroup }) {
    const styles = useGroupAdminStyles();

    const emptyGridText = isEditingDefaultGroup ? (
        <Trans>
            The <strong>Default</strong> group can view data from all Sites in the application
        </Trans>
    ) : (
        t`There are no Sites in this Group`
    );

    return (
        <FormSection title={t`Sites`}>
            <div className={styles.selectorWrapper}>
                <ListSelectorField
                    gridColumns={GROUPS_ADMIN_SITES_COLUMNS}
                    sorters={initialSort}
                    dbSelected={formData?.sites?.ids || []}
                    selectedDataSource={selectedDataSource}
                    availableDataSource={availableDataSource}
                    idsDataSource={idsDataSource}
                    fieldName={GROUPS_ADMIN_SITES_FIELD}
                    addButtonText={t`Add Sites`}
                    removeButtonText={t`Remove`}
                    setSelectionIsDirty={setSitesSelectionDirty}
                    selectedEmptyGridText={emptyGridText}
                    // Disable field and hide actions if user is editing the default group
                    disabled={isEditingDefaultGroup}
                    hideActions={isEditingDefaultGroup}
                />
            </div>
        </FormSection>
    );
}
